import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-file',
  templateUrl: './file-type.component.html',
  styleUrls: ['./file-type.component.css']
})
export class FormlyFieldFile extends FieldType implements OnInit {
  @ViewChild('fileInput') fileInput: ElementRef;
  fileName: string | null = null;

  ngOnInit(): void {
    if (this.formControl.value) {
      if (typeof this.formControl.value === 'object' && this.formControl.value.name)
        this.fileName = this.formControl.value.name;
    } else if (typeof this.formControl.value === 'string') {
      this.fileName = "Uploaded File";
    }
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    
    if (file) {
      this.fileName = file.name;
      const reader = new FileReader();

      reader.onload = () => {
        const fileValue = {
          name: file.name,
          
          // Base64 string
          content: reader.result
        };

        this.formControl.setValue(fileValue);
        this.formControl.markAsTouched();
      };
      reader.readAsDataURL(file);
    }
  }

  openFileInput() {
    this.fileInput.nativeElement.click();
  }

  removeFile() {
    this.fileName = null;
    this.formControl.setValue(null);
    this.fileInput.nativeElement.value = '';
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/components/schema-form/file-type-formly/file-type.component.ts